import { DataModule, TicketModule } from '@/app/shared/modules';
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

interface StoreType {
  ticketModule: TicketModule;
  dataModule: DataModule;
}

const vuexLocal = new VuexPersistence<StoreType>({
  key: 'tracker',
  storage: window.localStorage,
  reducer: (state) => ({
    ticketModule: state.ticketModule,
    dataModule: state.dataModule,
  }),
});

const store = new Vuex.Store<StoreType>({
  plugins: [vuexLocal.plugin],
});

export { store };
